module.exports = __webpack_public_path__ + "img/13_2.bbf9d19f.png";